import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { orderStatusLabel, panelSx } from "./detailUtils";

export const InfoItem = ({ label, value, strong = false }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography sx={{ fontSize: 12.5, color: "#64748b", lineHeight: 1.25 }}>{label}</Typography>
    <Typography
      sx={{
        mt: 0.4,
        fontSize: strong ? 18 : 14.5,
        fontWeight: strong ? 800 : 500,
        color: "#111827",
        lineHeight: 1.35,
        wordBreak: "keep-all",
      }}
    >
      {value || "-"}
    </Typography>
  </Box>
);

export const MetricCard = ({ label, value, tone = "#6c5ce7", helper, dense = false }) => (
  <Paper
    variant="outlined"
    sx={{
      p: dense ? 2 : 1.5,
      borderRadius: "8px",
      borderColor: `${tone}33`,
      bgcolor: "#fff",
      minHeight: dense ? 88 : 90,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: dense ? "center" : "stretch",
      textAlign: dense ? "center" : "left",
    }}
  >
    <Typography sx={{ fontSize: dense ? 12.5 : 12.5, color: "#64748b" }}>{label}</Typography>
    <Typography sx={{ mt: dense ? 0.5 : 0.4, fontSize: dense ? 22 : 24, lineHeight: 1.1, fontWeight: 900, color: tone }}>
      {value || "-"}
    </Typography>
    {helper && <Typography sx={{ mt: dense ? 0.5 : 0.5, fontSize: 12, color: "#64748b" }}>{helper}</Typography>}
  </Paper>
);

export const OssOrderDetailHeader = ({
  order,
  disabledByCancel,
  onBack,
  onEdit,
  onCancel,
  onDelete,
}) => (
  <Paper elevation={0} sx={{ ...panelSx, px: 2, py: 1.45 }}>
    <Stack direction={{ xs: "column", md: "row" }} spacing={1.4} alignItems={{ xs: "stretch", md: "center" }}>
      <Stack direction="row" spacing={1.2} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
        <Button startIcon={<ArrowBackRoundedIcon />} onClick={onBack} color="inherit" sx={{ flexShrink: 0 }}>
          목록
        </Button>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
            <Typography component="h1" noWrap sx={{ fontSize: { xs: 22, md: 26 }, fontWeight: 900, color: "#111827" }}>
              {order.order_no}
            </Typography>
            <Box
              sx={{
                px: 1.05,
                py: 0.35,
                borderRadius: "999px",
                bgcolor: disabledByCancel ? "#f3f4f6" : "#eef2ff",
                color: disabledByCancel ? "#6b7280" : "#4f46e5",
                fontSize: 12,
                fontWeight: 800,
                flexShrink: 0,
              }}
            >
              {orderStatusLabel[order.order_status] || order.order_status || "-"}
            </Box>
          </Stack>
          <Typography sx={{ mt: 0.25, fontSize: 13, color: "#64748b" }}>
            {order.customer_name} · {order.site_name || "납품처 미등록"}
          </Typography>
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={0.8}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ ml: { md: "auto" }, flexShrink: 0, flexWrap: "wrap" }}
      >
        <Button startIcon={<EditRoundedIcon />} variant="outlined" onClick={onEdit} disabled={disabledByCancel}>
          수정
        </Button>
        <Button variant="outlined" color="warning" onClick={onCancel} disabled={disabledByCancel}>
          취소
        </Button>
        <Button startIcon={<DeleteOutlineRoundedIcon />} variant="outlined" color="error" onClick={onDelete}>
          삭제
        </Button>
      </Stack>
    </Stack>
  </Paper>
);
